import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export type LiveViewMode = "map" | "chart";

interface LiveViewTabsProps {
  value: LiveViewMode;
  onChange: (value: LiveViewMode) => void;
}

export function LiveViewTabs({ value, onChange }: LiveViewTabsProps) {
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      aria-label="Live view display"
      onChange={(_, nextValue: LiveViewMode | null) => {
        if (nextValue) onChange(nextValue);
      }}
      sx={{
        height: 32,
        "& .MuiToggleButton-root": {
          px: 1.75,
          py: 0.25,
          color: "text.secondary",
          textTransform: "none",
          fontWeight: 700,
          borderColor: "divider",
          "&.Mui-selected": {
            color: "text.primary",
            backgroundColor: "action.selected",
          },
        },
      }}
    >
      <ToggleButton value="map">Map View</ToggleButton>
      <ToggleButton value="chart">Chart View</ToggleButton>
    </ToggleButtonGroup>
  );
}
